<template>
  <a-layout :style="{display: 'inline-block', 'min-width': '100%'}">
    <a-layout-header style="background: #fff; padding: 0">

      <div class="button-group-right">

        <a-week-picker
          @change="onWeekPickerChange"
          placeholder="Select week"
          :allowClear="false"
          :value="date"
          :open="weekPickerOpen"
          />

        <a-button-group>
          <a-tooltip placement="bottom" >
            <template slot="title">
                <span>Reset view</span>
            </template>
            <a-button icon="home" @click="onButtonReset" />
          </a-tooltip>

          <a-tooltip placement="bottom" >
            <template slot="title">
              <span>Goto week</span>
            </template>
            <a-button icon="calendar" @click="weekPickerOpen=true;" />
          </a-tooltip>

          <a-tooltip placement="bottom" >
            <template slot="title">
                <span>Show previous week</span>
            </template>
            <a-button icon="caret-up" @click="onButtonPrevWeekClick" />
          </a-tooltip>

          <a-tooltip placement="bottom" >
            <template slot="title">
                <span>Show following week</span>
            </template>
            <a-button icon="caret-down" @click="onButtonNextWeekClick" />
          </a-tooltip>

          <!--
          <a-dropdown :trigger="['click']">
            <a-menu slot="overlay">
              <a-menu-item key="1">
                Dummy one
              </a-menu-item>
              <a-menu-item key="2">Dummy two</a-menu-item>
              <a-menu-divider />
              <a-menu-item key="3">Dummy three</a-menu-item>
            </a-menu>
            <a-tooltip placement="bottom" >
              <template slot="title">
                  <span>Settings</span>
              </template>
              <a-button icon="setting" />
            </a-tooltip>
          </a-dropdown>
          -->
        </a-button-group>

      </div>

    </a-layout-header>

    <a-layout-content>
      <div>

        <Week
          v-for="{offsetDate, weekString} in weekOffsets.map(getWeekData)"
          :key="weekString"
          :date="offsetDate"
          :weekdays="weekdays"
          ></Week>

      </div>

    </a-layout-content>
  </a-layout>

</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import Week from '@/components/Week';
import { range } from '@/utils';


export default {
  name: "Planner",
  components: {
    Week
  },
  computed: {
    ...mapGetters({
      userPreferences: 'prefs/getUserPreferences',
      userData: 'userdata/getUserdata'
    }),
    weekdays() {
      return this.userPreferences["planner.weekdays"];
    },
  },
  created(){
    this.weekOffsets = range(
      -this.userPreferences["planner.numberPrevWeeks"],
      this.userPreferences["planner.numberNextWeeks"] + 1);
    this.date.locale(this.userData().locale);
    window.addEventListener('visibilitychange', this.onVisibilitychange);
  },
  destroyed(){
    window.removeEventListener('visibilitychange', this.onVisibilitychange);
  },
  data() {
    return {
      weekOffsets: [],
      date: moment(),  // date of shown week
      weekPickerOpen: false,
    }
  },
  methods: {
    onButtonPrevWeekClick() {
      this.weekOffsets.splice(0, 0, this.weekOffsets[0] - 1);
    },
    onButtonNextWeekClick() {
      this.weekOffsets.push(this.weekOffsets[this.weekOffsets.length - 1] + 1);
    },
    onButtonReset() {
      this.date = moment().locale(this.userData().locale);
      this.weekOffsets = range(
        -this.userPreferences["planner.numberPrevWeeks"],
        this.userPreferences["planner.numberNextWeeks"] + 1);
    },
    onVisibilitychange() {
      this.$store.commit('weeks/updateToday');
    },
    onWeekPickerChange(momentDate) {
      if (momentDate) {
        this.date = momentDate.locale(this.userData().locale);
      }
      this.weekPickerOpen = false;
    },
    getWeekData(woffset) {
      let weekDate = moment(this.date).add(woffset, "weeks");
      weekDate.locale(this.userData().locale);
      return {
        offsetDate: weekDate,
        weekString: weekDate.format("YYYY-W"),
      }
    }
  }
}
</script>

<style scoped>

.button-group-right {
  float: right;
  margin-right: 15px;
}

.ant-calendar-picker {
  visibility: hidden
}

</style>

